import { useCallback } from 'react';
import {
  SortingToggleOptions,
  SortingDirection,
} from '../../screens/Overview/types';
import './index.css';
import { HiTrendingDown, HiTrendingUp } from 'react-icons/hi';
import { colors } from '../../colors';
import useWidthBreakpoint from '../../hooks/useWidthBreakpoint';
import DropdownComponent from '../../components/Form/Dropdown';

interface Props {
  options: Array<SortingToggleOptions>;
  activeOption: SortingToggleOptions;
  handleOptionPress: (toggleOption: any) => void;
  sortingDirection?: SortingDirection;
}

const Toggles: React.FC<Props> = (props: Props) => {
  const { options, activeOption, handleOptionPress, sortingDirection } = props;
  const { isMatch } = useWidthBreakpoint();

  const isActive = useCallback(
    (option: SortingToggleOptions) =>
      option === activeOption ||
      (option === SortingToggleOptions.Diversity &&
        activeOption === SortingToggleOptions.TotalValue) ||
      (option === SortingToggleOptions.TotalValue &&
        activeOption === SortingToggleOptions.Diversity),
    [activeOption],
  );

  const getItemStyle = useCallback(
    (option: SortingToggleOptions) => {
      return `chart-toggles-item ${isActive(option) ? 'active' : ''}`;
    },
    [isActive],
  );

  if (!isMatch('md')) {
    return (
      <DropdownComponent
        config={{
          label: 'Sort By:',
          value: activeOption,
          handleValueChange: handleOptionPress,
          options: Object.values(SortingToggleOptions),
          fullWidth: true,
        }}
      />
    );
  }

  return (
    <div
      className="chart-toggles-container"
      style={{ flexWrap: 'wrap', rowGap: 8 }}
    >
      {options.map((option) => (
        <div
          key={option}
          className={getItemStyle(option)}
          onClick={() => handleOptionPress(option as any)}
        >
          <span className="chart-toggles-text">{option}</span>
          {!!sortingDirection &&
            isActive(option) &&
            (sortingDirection === SortingDirection.Descending ? (
              <HiTrendingDown
                color={colors.red}
                size={24}
                className={'sortingDirectionIcon'}
              />
            ) : (
              <HiTrendingUp
                color={colors.green}
                size={24}
                className={'sortingDirectionIcon'}
              />
            ))}
        </div>
      ))}
    </div>
  );
};

export default Toggles;
